'use client';

import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { useContext } from 'react';
import Input from '../../Input/index.js';
import { FormContext } from '../index.js';

function FMInput(_a) {
    var name = _a.name; _a.width; var label = _a.label, trimValue = _a.trimValue, rest = __rest(_a, ["name", "width", "label", "trimValue"]);
    var _b = useContext(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Input, __assign({}, rest, { value: values[name], onChange: function (value) {
                var _a;
                var inputValue = value;
                if (trimValue) {
                    inputValue = value.trimStart();
                }
                setValues(__assign(__assign({}, values), (_a = {}, _a[name] = inputValue, _a)));
                onAnyChange(value, name);
            }, label: label, hasError: showError, onFocus: function () {
                var _a;
                setTouched(__assign(__assign({}, touched), (_a = {}, _a[name] = true, _a)));
            } })),
        showError && React__default.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}

export { FMInput as default };
//# sourceMappingURL=index.js.map
